import { useContent } from "../ContentContext";
import DarkFooter from "../sections/DarkFooter";

const ProductsPage = () => {
  const content = useContent();

  return (
    <div className="bg-dark text-light h-screen flex flex-col">
      {/* Full-Screen Section */}
      <section className="relative flex-grow h-full text-white">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/productpage.png"
        >
          <source src="/videos/productpage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/50 via-dark/90 to-dark"></div>

        {/* Centered Content */}
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div className="flex flex-col items-center max-w-4xl">
            {/* Subtitle */}
            <p className="uppercase text-lg sm:text-2xl tracking-wide font-garet">
              {content.productpage.subtitle}
            </p>

            {/* Title */}
            <h1 className="text-4xl sm:text-7xl my-4 font-bodoni">
              {content.productpage.title}
            </h1>

            {/* Product List */}
            <div className="mt-4">
              {content.productpage.products.map((product, index) => (
                <div key={index} className="mb-2">
                  <h2 className="text-lg sm:text-3xl font-garet">{product}</h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {DarkFooter()}
    </div>
  );
};

export default ProductsPage;
